import { useUserHasAccess } from '@backoffice-frontend/restricted'
import {
  AREA_ACCESS_RIGHTS,
  AREA_CRUD_RIGHTS,
  DASHBOARD_READ_RIGHTS,
  LINE_SERVICE_ANY_ACCESS_RIGHTS,
  LINE_SERVICE_CRUD_RIGHTS,
  STOP_BULK_CRUD_RIGHTS,
  STOP_CRUD_RIGHTS,
  STOP_DRIVER_VOTING_RIGHTS,
} from '../permissions'

/**
 * Central hook that returns all stop-network permission checks.
 *
 * Prefer this hook when a component needs multiple permission checks.
 * For components that only gate on a single right you can also use
 * the constants from `permissions.ts` directly with `<Restricted>` or
 * `useUserHasAccess`.
 */
export const useStopNetworkPermissions = () => {
  const canAccessArea = useUserHasAccess({
    requiredRights: [...AREA_ACCESS_RIGHTS],
  })
  const canReadDashboard = useUserHasAccess({
    requiredRights: [...DASHBOARD_READ_RIGHTS],
  })
  const canEditStops = useUserHasAccess({
    requiredRights: [...STOP_CRUD_RIGHTS],
  })
  const canBulkImportStops = useUserHasAccess({
    requiredRights: [...STOP_BULK_CRUD_RIGHTS],
  })
  const canSeeDriverVoting = useUserHasAccess({
    requiredRights: [...STOP_DRIVER_VOTING_RIGHTS],
  })
  const canEditAreas = useUserHasAccess({
    requiredRights: [...AREA_CRUD_RIGHTS],
  })
  const canEditLineService = useUserHasAccess({
    requiredRights: [...LINE_SERVICE_CRUD_RIGHTS],
  })
  const canAccessLineService = useUserHasAccess({
    allowedRights: [...LINE_SERVICE_ANY_ACCESS_RIGHTS],
  })

  return {
    canAccessArea,
    canReadDashboard,
    canEditStops,
    canBulkImportStops,
    canSeeDriverVoting,
    canEditAreas,
    canEditLineService,
    canAccessLineService,
  }
}
